/**
 * The chart indicator chips a signal can say it needs.
 *
 * A PICKER CONVENIENCE, not a second source of truth. The chips themselves are
 * built inside ChartsPage's toolbar memo, which depends on component state and
 * cannot be imported from here, so this is a hand-kept key/label list.
 *
 * Two things stop it rotting into a lie:
 *   - verifyGoldenSignals asserts every key below exists in the `Overlays`
 *     interface in TradingChart.tsx, so this file can never offer a chip that
 *     does not exist;
 *   - the editor's indicator field is freeSolo, so a NEW chip that nobody has
 *     added here yet can still be typed in. Drift therefore costs convenience,
 *     never correctness.
 */
export interface OverlayOption { key: string; label: string }

export const CHART_OVERLAY_CATALOGUE: OverlayOption[] = [
  // Bands & Levels
  { key: 'avgCloud', label: 'AvgCloud' },
  { key: 'cpr', label: 'CPR' },
  { key: 'ctfPoc', label: 'C-POC' },
  { key: 'htfPoc', label: 'H-POC' },
  { key: 'mm', label: 'MM' },
  { key: 'blast', label: 'Blast' },
  { key: 'bolev4h', label: 'BO_4H' },
  { key: 'bolevD', label: 'BO_D' },
  { key: 'bolevW', label: 'BO_W' },
  { key: 'clhBand', label: 'CLH Band' },
  { key: 'clnBreakLevels', label: 'CLN Brk' },
  { key: 'clnHtfBand', label: 'HTF Band' },
  { key: 'lrBody', label: 'LR body' },
  { key: 'hlDiff', label: 'HLDiff' },
  { key: 'vob', label: 'VOB' },
  { key: 'avBand', label: 'AV_Band' },
  { key: 'sr', label: 'S/R' },
  { key: 'bollingerEnvelope', label: 'Bollinger' },
  // Trend
  { key: 'dbcrZone', label: 'DbCrZone' },
  { key: 'combinedMidline', label: 'CMid' },
  { key: 'ema200', label: 'EMAs' },
  { key: 'lrHama', label: 'LR_HAMA_Band' },
  { key: 'lrc', label: 'LRC' },
  // Oscillators
  { key: 'macd', label: 'MACD' },
  { key: 'jhm', label: 'JHM' },
  { key: 'wrPct', label: 'WR%' },
  { key: 'dayChange', label: 'ChgN%' },
  { key: 'relStrength', label: 'RelStrength' },
  { key: 'bbrOsc', label: 'BBR (oscillator)' },
  { key: 'waveOsc', label: 'Wave (oscillator)' },
  { key: 'synthiya', label: 'Synthiya' },
  { key: 'flow', label: 'Flow' },
  { key: 'vol', label: 'HVol' },
  { key: 'volume', label: 'Volume' },
  // Overlays / tints
  { key: 'bbrColor', label: 'BBR tint' },
  { key: 'spikeColor', label: 'Vol spike tint' },
  { key: 'vpa', label: 'VPA' },
  { key: 'funding', label: 'Funding' },
  { key: 'fno', label: 'FNO' },
  // Signals
  { key: 'fllhh', label: 'FLLHH' },
  { key: 'fbo', label: 'FBO' },
  { key: 'wave', label: 'Wave arrows' },
  { key: 'as', label: 'ASH' },
];
